import React, { useState } from "react";
import OnioTabs from "../../Components/OnioTabs/index";
import VideoRemote from "../../Components/VideoRemote/index";
import "./index.css";
import { TabMenus } from "../../Utils/Types";
import Box from "@mui/material/Box";
import { Container } from "@mui/material";

const Video = () => {
  const [tab, setTab] = useState<number>(0);
  const handleMenuNavigation = (ele: any, i: number) => {
    setTab(i);
  };
  return (
    <Container maxWidth="lg">
      <OnioTabs menu={TabMenus} onClick={handleMenuNavigation} />
      <Box className="grid-remote">
        <Box>
          <VideoRemote title={"Epson Projector"} projectorRemote={false} />
        </Box>
        <Box>
          <VideoRemote title={"Epson Projector"} projectorRemote={true} />
        </Box>
      </Box>
    </Container>
  );
};

export default Video;
